import { Autocomplete, TextField } from "@mui/material";
import React, { useState } from "react";

const MAX_VISIBLE_OPTIONS = 100;
const SearchAndSelect = ({ value, onchange, options = [], handleSearchClear, isError, useBlackTheme = false }) => {
  const [inputValue, setInputValue] = useState("");

  return (
    <>
      <Autocomplete
        id="size-small-outlined"
        options={options.length ? options : []}
        // freeSolo
        freeSolo={false}
        value={value || ""}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        onChange={(event, newValue) => {
          onchange(newValue || "");
          setInputValue(newValue?.label || "");
        }}
        getOptionLabel={(option) => (typeof option === "string" ? option : option.label)}
        popupIcon={null}
        disableClearable={!value} // 👈 disables clear icon if no value
        clearIcon={
          <span onClick={() => handleSearchClear()} style={{ fontSize: ".9vw", cursor: "pointer", width: "1.1vw" }}>
            ×
          </span>
        }
        filterOptions={(options, state) => {
          const input = (state.inputValue || "").toLowerCase();

          const filtered = options.filter((opt) => (typeof opt === "string" ? opt : opt.label)?.toLowerCase().includes(input));

          if (filtered.length === 0 && input.trim() !== "") {
            return [{ label: "Binny’s Jewellery Pvt. Ltd. (Client not Found)", partyCode: "BJPL", partyNo: 1000001, clientName: "Binny’s Jewellery Pvt. Ltd." }];
          }

          // Render only first N matches; full list in DOM makes popup/typing slow
          return filtered.slice(0, MAX_VISIBLE_OPTIONS);
        }}
        autoHighlight
        ListboxProps={{
          sx: {
            backgroundColor: useBlackTheme ? "#fff" : "white",
            color: useBlackTheme ? "black" : "black",
            padding: ".25vw",
            textAlign: "center",
            "& .MuiAutocomplete-option": {
              justifyContent: "start",
              backgroundColor: useBlackTheme ? "#fff" : "white",
              color: useBlackTheme ? "black" : "black",
              fontFamily: "Karla",
              fontSize: ".9vw",
              fontWeight: "400",
              lineHeight: "1.1vw",
              letterSpacing: "-0.41px",
              textAlign: "center",
              textTransform: "capitalize",
              "& input": {
                textAlign: "center",
              },
              "&:hover": {
                backgroundColor: "#444444",
                color: "white",
                borderRadius: ".25vw",
              },
            },

            // ✅ Add this block to highlight focused option via keyboard
            "& .Mui-focused": {
              backgroundColor: "#444444 !important",
              color: "white",
              borderRadius: ".25vw",
            },

            // ✅ Keep selected styling too
            '& .MuiAutocomplete-option[aria-selected="true"]': {
              backgroundColor: "#444444 !important",
              color: "white",
              borderRadius: ".25vw",
              fontFamily: "Karla",
              fontSize: ".9vw",
              fontWeight: "400",
              lineHeight: "1.1vw",
              letterSpacing: "-0.41px",
            },
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            type="text"
            placeholder="Enter client name"
            inputProps={{
              ...params.inputProps,
              readOnly: !!value && options.includes(value),
            }}
            onKeyDown={(e) => {
              if (e.key >= "0" && e.key <= "9") {
                e.preventDefault();
              }
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: "2.5vw", // input box height
                borderRadius: ".25vw",
                backgroundColor: "transparent",
                fontFamily: "Karla",
                fontSize: ".9vw",
                fontWeight: "400",
                lineHeight: "1.1vw",
                letterSpacing: "-0.41px",
                "& input": {
                  textTransform: "capitalize", // ✅ capitalizes input value
                },
                "& input::placeholder": {
                  textTransform: "capitalize",
                },
                "& fieldset": {
                  borderColor: isError ? "#F23D3D" : useBlackTheme ? "#000" : "white", // actual visible border color
                },
                "&:hover fieldset": {
                  borderColor: useBlackTheme ? "#000" : "none", // border color on hover
                },
                "&.Mui-focused fieldset": {
                  border: `0.5px solid ${useBlackTheme ? "#000" : "white"}`,
                  boxShadow: "none", // remove blue glow
                  outline: "none", // remove any browser-specific outline
                },
              },
              "& .MuiInputBase-input": {
                color: useBlackTheme ? "#000" : "inherit",
              },
              "& .MuiSvgIcon-root": {
                color: useBlackTheme ? "#000" : "inherit",
              },
              background: isError ? "#F23D3D08" : "transparent",
            }}
          />
        )}
      />
    </>
  );
};

export default SearchAndSelect;
